<template>
  <section class="quotes--quote-header">
    <fixed-header :title="pageTitle" :listPage="($route.name == 'proforma-invoice.edit') ? '/proforma-invoices': '/invoices'" hideNewOfferBtn>
      <template v-slot:left>
        <b-badge v-if="invoice.isShipped" class="ml-1" variant="primary">Shipped</b-badge>
        <b-badge  v-if="invoice.balance <= 0 && invoice.amountPaid > 0" class="ml-1" variant="success">Paid</b-badge>
      </template>
      <template v-slot:center>
        <a class="mr-2">Contact</a>
        <div class="edit-contact-container mr-1">
          <edit-contact :companyId="invoice.companyId" :inlineButton="true" ref="editModal"
            @created="onContactCreated"></edit-contact>
        </div>
        <b-form-select class="mr-5 contact-header-form-select" v-model="invoice.contactId">
          <option v-for="(select, index) in sortSelect(contacts,'firstName')" :key="index" :value="select.id">
            {{ select.firstName + ' ' + select.lastName }}</option>
        </b-form-select>
        <h6 class="status mb-0 mr-5">Status: {{ invoice.statusName }}</h6>
        <a class="mr-2 flex-shrink-zero">Sales Rep</a>
        <b-form-select v-model="invoice.salesPersonUserId" class="w-auto mr-2">
          <option v-for="(selectRep, indexRep) in sortSelect(salesReps)" :key="indexRep" :value="selectRep.id">
            {{ selectRep.name }}
          </option>
        </b-form-select>
        <span v-if="invoice.salesOrderId" class="ml-3">
          <h6 class="mb-0 mr-2">Sales Order:</h6>
          <a class="selector-link" @click="$router.push({ name: 'salesorders.edit', params: {id: invoice.salesOrderId} })">
            {{ invoice.salesOrderId }}
          </a>
        </span>
        <span v-if="invoice.isAuthorized" class="ml-3">
          <h6 class="mb-0 mr-2">Authorized by:</h6>
          <a class="mr-2">{{ invoice.authorizedByUserFullName + ' on ' + date(invoice.dateAuthorized) }}</a>
        </span>
        <span v-if="invoice.dateEmailed" class="ml-3">
          <h6 class="mb-0 mr-2">Mailed at:</h6>
          <a class="mr-2">{{ date(invoice.dateEmailed) }}</a>
        </span>
        <!-- <b-button
          variant="primary"
          size="sm"
          @click="authorizeQuote(quoteId)"
        >
          {{ invoice.dateAuthorized ? 'Unauthorize' : 'Authorize' }}
        </b-button> -->
      </template>
    </fixed-header>

    <b-card class="quotes-header mb-1">
      <div class="d-flex">
        <address-selector
          @input="invoice.billingAddressId=$event.id, invoice.billingAddress=$event.newAddr"
          :value="invoice.billingAddress"
          :addressId="invoice.billingAddressId"
          title="Bill to"
          width="300"
          :accountId="invoice.companyId"
          class="mr-4"
        />
        <address-selector
          @input="invoice.shippingAddressId=$event.id, invoice.shippingAddress=$event.newAddr"
          :value="invoice.shippingAddress"
          :addressId="invoice.shippingAddressId"
          title="Ship to"
          width="300"
          :accountId="invoice.companyId"
          class="mr-4"
        />
        <div class="d-flex flex-column mr-3" style="width: 150px;">
        <b-form-group label="Invoice Date" class="mb-2">
          <date-picker v-model="invoiceDate" :config="datePickerOptions"></date-picker>    
        </b-form-group>
        <b-form-group label="Ship Date">
          <date-picker v-model="shipDate" :config="datePickerOptions"></date-picker>    
        </b-form-group>
        </div>
        <div class="d-flex flex-column header-field-width mr-3">
          <!-- <b-form-group label-cols="4" label-align="right" label="Invoice #">
            <b-form-input disabled v-model="invoice.invoiceNumber" :config="datePickerOptions"></b-form-input>
          </b-form-group> -->
          

          <b-form-group label-cols="4" label-align="right" label="Terms" class="required">
            <b-form-select v-model="invoice.billingTermId" :class="{ 'is-invalid': $v.invoice.billingTermId.$error }">
              <option v-for="(select, index) in sortSelect(quoteTerms)" :key="index" :value="select.id">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Inco Terms" class="required">
            <b-form-select v-model="invoice.incoTermId" :class="{ 'is-invalid': $v.invoice.incoTermId.$error }">
              <option v-for="(type) in sortSelect(incoTerms)" :key="type.id" :value="type.id">{{type.name}}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Cust PO #">
            <b-form-input v-model="invoice.customerPO"> </b-form-input>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="VAT #">
            <b-form-input v-model="invoice.taxNumber" />
          </b-form-group>
          <b-alert variant="success" class="mt-1 text-center" show size="sm" v-if="invoice.balance <= 0 && invoice.amountPaid > 0"><strong>PAID</strong></b-alert>
          <!-- <b-form-group label-cols="4" label-align="right" label="Sales Order #">
            <div class="mt-1">
              <a class="selector-link" @click="$router.push({ name: 'salesorders.edit', params: {id: invoice.salesOrderId} })">{{ invoice.salesOrderId }}</a>
            </div>
          </b-form-group> -->
          <!-- <b-form-group label-cols="4" label-align="right" label="Sale Type">
            <b-form-select v-model="invoice.salesTypeId">
              <option v-for="(type) in sortSelect(salesTypes)" :key="type.id" :value="type.id">{{type.name}}</option>
            </b-form-select>
          </b-form-group> -->
          <!-- <b-form-group label-cols="4" label-align="right" label="Date Auth">
            <date-picker disabled v-model="invoice.dateAuthorized" :config="datePickerOptions"></date-picker>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Date Emailed">
            <date-picker disabled v-model="invoice.dateEmailed" :config="datePickerOptions"></date-picker>
          </b-form-group> -->
        </div>
        <div class="d-flex flex-column header-field-width mr-3">
          <b-form-group label-cols="4" label-align="right" label="Ship Via" class="required">
            <b-form-select v-model="invoice.shippingProviderId" @change="onShippingAccountChange(true)">
              <option v-for="(select, index) in sortSelect(shippingProviders)" :key="index" :value="select.id">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Ship Method" :class="{'required': this.isRequiredShipDetails }">
            <b-form-select v-model="invoice.shippingMethodId" :class="{ 'is-invalid': $v.invoice.shippingMethodId.$error }">
              <option v-for="(select, index) in sortSelect(shipMethods)" :key="index" :value="select.id">{{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Ship On" :class="{'required': this.isRequiredShipDetails }">
              <b-form-select v-model="invoice.alwaysShipBy" @change="onShippingAccountChange(false)" :class="{ 'is-invalid': $v.invoice.alwaysShipBy.$error }">
                <option value="0"></option>
                <option value="1">Customer</option>
                <option value="2">House Account</option>
              </b-form-select>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Ship Acct #">
            <b-input-group size="sm">
              <b-form-input v-model="invoice.shippingAccountNumber" />
            </b-input-group>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Tracking #" v-if="!invoice.isProforma">
            <b-input-group size="sm">
              <b-form-input v-model="invoice.trackingNumber" />
              <b-input-group-append v-if="trackingLink">
                <b-button variant="primary" id="tooltip-button-not-interactive" @click="onNavigate">TRK</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="d-flex flex-column header-field-width mr-3">
          <b-form-group label-cols="4" label-align="right" label="ITN">
            <b-form-input v-model="invoice.shipmentDetails_ITN"> </b-form-input>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Weight">
            <b-form-input v-model="invoice.shipmentDetails_Weight" />
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Carton">
            <b-form-input type="number" v-model="invoice.shipmentDetails_Cartons" min="0"> </b-form-input>
          </b-form-group>
          <b-form-group label-cols="4" label-align="right" label="Dims">
            <b-form-input v-model="invoice.shipmentDetails_Dims1" />
          </b-form-group>
          <b-form-group label-cols="4" label-align="right">
            <b-form-input v-model="invoice.shipmentDetails_Dims2" />
          </b-form-group>
        </div>
      </div>
    </b-card>
  </section>
</template>

<script>
  import {
    mapGetters,
    mapActions,
    mapState
  } from 'vuex';
  import moment from 'moment';
  import {
    DATE_FORMAT
  } from '@/shared/constants';
  //import { GRID_ID, SAVE_SETTINGS_DELAY } from '@/shared/constants';

  import EditContact from '@/pages/Company/components/CompanyDetails/tabs/Contacts/components/EditContact/index';
  //import EditAddress from '@/pages/Company/components/CompanyDetails/tabs/Addresses/components/EditAddress/index';
  import AddressSelector from '@/shared/components/AddressSelector/index';
  import FixedHeader from '@/shared/components/FixedHeader/indexNew';
  import { date } from '@/shared/filters';
  import { required, requiredIf, minValue } from 'vuelidate/lib/validators';
  const isMinValue = function(val) { return this.isRequiredShipDetails ? val > 0 : val >= 0; }

  export default {
    components: {
      EditContact,
      //EditAddress,
      AddressSelector,
      FixedHeader,
    },
    data() {
      return {
        date,
        text: '11111111',
        invoiceDate: '',
        shipDate: '',
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
          widgetPositioning:{
            horizontal: 'left',
            vertical: 'bottom',
          } 
        },
      }
    },
    watch: {
      async invoice() {
        if (this.invoice.companyId) {
          this.getContacts(this.invoice.companyId);
          this.getShippingAccounts(this.invoice.companyId);
          if (Object.keys(this.company).length == 0) {
            this.getCompanyById(this.invoice.companyId);
          }
        }

        this.invoiceDate = moment(this.invoice.invoiceDate).format(DATE_FORMAT);
        this.shipDate = moment(this.invoice.shipDate).format(DATE_FORMAT);

        if(!this.invoice.currencyId) this.invoice.currencyId = 1;
        if(!this.invoice.exchangeRate) this.invoice.exchangeRate = 1;
      },
    },
    computed: {
      ...mapGetters('companies', ['companyById']),
      ...mapState('invoices', ['invoice']),
      ...mapState('salesReps', ['salesReps']),
      ...mapGetters('shippingAccount', ['shippingAccountsList']),
      // ...mapState('quoteDetails', [
      //   'quotes',
      // ]),
      ...mapGetters('lookup', ['salesTypes', 'incoTerms', 'currencies', 'shippingProviders', 'shipViaList', 'houseShippingAccounts']),
      // ...mapGetters('quoteDetails', [
      //   'chargesById',
      //   'quoteById',
      //   'contacts',
      //   'quoteTerms',
      //   'quoteStatuses',
      // ]),

      ...mapGetters('quoteDetails', [
        'contacts',
        'quoteTerms',
      ]),

      pageTitle() {
        let invoiceTitle = (this.invoice.isProforma) ? 'Proforma' : 'Invoice' ;
        return `${invoiceTitle}: ${this.invoiceId} - ${this.invoice.companyName}`;
      },
      invoiceId() {
        return this.$route.params.id;
      },
      // quote() {
      //   // return this.quotes[this.quoteId];
      //   return this.quoteById(this.quoteId);
      // },
      status() {
        var rtn = '';
        switch (this.invoice.statusId) {
          case 1:
            rtn = 'OPEN';
            break;
          case 2:
            rtn = 'WON';
            break;
          case 3:
            rtn = 'LOST';
            break;
          default:
            rtn = '';
            break;
        }
        return rtn;
      },
      shipMethods() {
        if (this.invoice.shippingProviderId) {
          return this.shipViaList.filter(ship => ship.shippingProviderId == this.invoice.shippingProviderId);
        } else {
          return [];
        }
      },
      company() {
        var result = this.companyById(this.invoice.companyId);
        return result;
      },
      isRequiredShipDetails() {
        return (this.shippingProviders.length > 0 && this.invoice) ? this.shippingProviders.filter(prov => prov.name != "TBD" && prov.name != "Unassigned")
          .map(x => x.id).includes(this.invoice.shippingProviderId) : false;
      },
      trackingLink() {
        if (this.shippingProviders.length > 0 && this.invoice.shippingProviderId > 0 && this.invoice.trackingNumber != "" && this.invoice.trackingNumber != null) {
          let shipProvider = this.shippingProviders.find(x => x.id == this.invoice.shippingProviderId);
          if (shipProvider && shipProvider.trackingUrl != null) {
            let tempUrl = shipProvider.trackingUrl;
            let url = tempUrl.replace("{0}", this.invoice.trackingNumber);
            return url.startsWith("https://") ? url : "https://" + url;

          }
        } 
        
        return null;
      }
    },
    methods: {
      ...mapActions('salesReps', ['getSalesReps']),
      // ...mapActions('quoteDetails', [
      //   'getById',
      //   'getQuoteTerms',
      //   'getQuoteStatuses',
      //   'getContacts',
      // ]),

      ...mapActions('quoteDetails', ['getContacts']),
      ...mapActions('shippingAccount', ['getShippingAccounts']),
      ...mapActions('companies', { getCompanyById: 'getById' }),
      async onContactCreated(id) {
        this.getContacts(this.invoice.companyId);
        //this.quote.contactId = id;
      },
      onShippingAccountChange(isProviderChange = false) {
        if (isProviderChange) {
          let prov = this.shippingProviders.find(x => x.id == this.invoice.shippingProviderId);
          if (prov && prov.name == "TBD") {
            // auto set method if the provider is TBD
            let sMthd = this.shipViaList.find(x => x.shippingProviderId == this.invoice.shippingProviderId);
            this.invoice.shippingMethodId = (sMthd) ? sMthd.id : 0;
            
          } else {
            this.invoice.shippingMethodId = 0;
          }
        }
        let shipAccts = null;

        // If ship by is Customer
        if (this.invoice.alwaysShipBy == 1) {
          shipAccts = this.shippingAccountsList.find(x => x.shippingProviderId == this.invoice.shippingProviderId);
        } else if (this.invoice.alwaysShipBy == 2) {
          shipAccts = this.houseShippingAccounts.find(x => x.shippingProviderId == this.invoice.shippingProviderId);
        }

        this.invoice.shippingAccountNumber = shipAccts != null ? shipAccts.accountNumber : null;
      },
      getHeaderValidation() {
        this.$v.$touch();
        this.$emit('header-validation', this.$v.$invalid);
      },
      onNavigate() {
        window.open(this.trackingLink, "_blank");
      }
    },
    validations: {
      invoice: {
        incoTermId: {required},
        billingTermId: {required},
        shippingProviderId: {required},
        shippingMethodId: { 
          required: requiredIf(function() { return this.isRequiredShipDetails }),
          isMinValue
        },
        alwaysShipBy: {
          required: requiredIf(function(){ return this.isRequiredShipDetails } ),
          isMinValue

        },
      }
    },
    async mounted() {
      this.invoiceDate = moment(this.invoice.invoiceDate).format(DATE_FORMAT);
      this.shipDate = moment(this.invoice.shipDate).format(DATE_FORMAT);
    },
  };

</script>

<style lang="scss" scoped>
  .selector-link {
    color: #20a8d8 !important;
    font-size: 100%;
    font-weight: 700;
    padding-bottom: 1px;
  }

  .selector-link:hover {
    color: #167495 !important;
    text-decoration: underline !important;
    cursor: pointer;
  }
</style>

